import { render, staticRenderFns } from "./AudienceAgeGroup.vue?vue&type=template&id=1b7cc760&scoped=true"
import script from "./AudienceAgeGroup.vue?vue&type=script&lang=js"
export * from "./AudienceAgeGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7cc760",
  null
  
)

export default component.exports